import React from "react";

const UserCard = ({ className, username, position, userProfilePic }) => {
  return (
    <div
      className={`flex flex-row items-center justify-center space-x-4 ${className}`}
    >
      <img
        alt="User Profile"
        src={userProfilePic}
        className="w-14 h-14 flex items-center justify-center object-cover rounded-full bg-black"
      />
      <div className="flex flex-col items-start">
        <p className="text-base font-bold leading-snug items-center text-center tracking-normal ">
          {username}
        </p>
        <p className="text-sm leading-snug items-center text-center tracking-normal ">
          {position}
        </p>
      </div>
    </div>
  );
};

export default UserCard;
